import { Colors, Typography, Spacing } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import { Icon20 } from 'cio-design-library/icons'
import { ButtonV2 } from 'builder/components/Button'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${Media.Phone`
    gap: 10px;
  `}
`

export const ImproveScoreContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ImproveScoreBadgeContainer = styled.div`
  padding: 10px 7px;
  border-radius: 8px;
  background-color: ${Colors.Green10};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ImproveScoreBadge = styled.div`
  padding: 2px;
  border-radius: 4px;
  background-color: ${Colors.Green40};
  color: ${Colors.White};
  ${Typography.sizes.Tiny};
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${Spacing.XS};
`

export const StyledButton = styled(ButtonV2)`
  flex: auto;
`

export const ArrowTargetIcon = styled(Icon20.ArrowTarget2)`
  width: 24px;
  height: 24px;
`
